import React, { Fragment } from 'react'
import { Info as InfoIcon } from 'react-feather'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Skeleton } from '@material-ui/lab'
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core'

import useStyles from './styles'

const DashboardNumberCard = ({
  label,
  value = 0,
  isLoading,
  tooltipProps = {},
}) => {
  const classes = useStyles()

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" className={classes.container}>
        <Box className={classes.labelBox} py={2}>
          <Typography variant="body1" className={classes.label}>
            {label}
          </Typography>
          {!isEmpty(tooltipProps) && (
            <Tooltip {...tooltipProps}>
              <IconButton
                size="small"
                color="inherit"
                className={classes.iconButton}
              >
                <InfoIcon size={16} className={classes.infoIconSup} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        {isLoading ? (
          <Skeleton width="100%" height="100%" variant="rect" />
        ) : (
          <Box className={classes.valueBox}>
            <Typography variant="h1" className={classes.value}>
              {value}
            </Typography>
          </Box>
        )}
      </Box>
    </Fragment>
  )
}

DashboardNumberCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  tooltipProps: PropTypes.object,
}

export default DashboardNumberCard
